import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateEvent($companyId: ID!, $id: ID!, $attributes: EventAttributes!) {
    updateEvent(companyId: $companyId, id: $id, attributes: $attributes) {
      event {
        id
        ...UpdatedEvent
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedEvent on Event {
    id
    description
    details
    dateOut
    dateStart
    dateEnd
    dateReturn
    warehouse { id name address }
    venue { id name address }
    client { id clientType { name color } }
    state
  }
`
